var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27245 18.94C7.88192 18.5495 7.88192 17.9163 8.27245 17.5258L13.7982 12L8.27245 6.47423C7.88192 6.08371 7.88192 5.45054 8.27245 5.06002C8.66297 4.66949 9.29614 4.66949 9.68666 5.06002L15.5759 10.9493C15.7138 11.0824 15.825 11.2422 15.902 11.42C15.9021 11.4202 15.9022 11.4204 15.9022 11.4207L14.9842 11.8171L15.9017 11.4193C15.9018 11.4195 15.9019 11.4198 15.902 11.42C15.9815 11.6037 16.0221 11.8011 16.0221 12C16.0221 12.1991 15.9814 12.3968 15.9017 12.5807L14.9842 12.1829L15.9022 12.5794C15.8253 12.7574 15.714 12.9174 15.5759 13.0507L15.5839 13.0427L14.8768 12.3356L15.5614 13.0646C15.5663 13.06 15.5711 13.0554 15.5759 13.0507L9.68666 18.94C9.29614 19.3305 8.66297 19.3305 8.27245 18.94Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChevronRight.90cb0c698aac59205c4824caaa792a64.svg";